
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-assets-icons-tickets_svg-icon-tickets-clip0)"}},[_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M11.986 3a.688.688 0 00.971.971l.222-.221a.333.333 0 01.471 0l2.093 2.093a.667.667 0 010 .942l-8.958 8.957a.667.667 0 01-.942 0L.187 10.085a.667.667 0 010-.942L9.143.186a.667.667 0 01.943 0l2.121 2.12a.333.333 0 010 .472l-.221.221V3zM9.614.657L.658 9.614l5.657 5.657 8.956-8.957-1.857-1.857a1.353 1.353 0 01-1.913-1.914L9.614.657zM7.021 2.78a.333.333 0 01.472-.472l1.414 1.414a.333.333 0 11-.472.472L7.021 2.779zM5.137 9.85a.334.334 0 11-.472-.471l3.3-3.3a.333.333 0 01.471.471l-3.3 3.3zm2.828 0a.333.333 0 11-.472-.471L9.38 7.493a.333.333 0 01.472.471L7.965 9.85zm1.414-4.714a.334.334 0 01.472-.472l1.414 1.415a.334.334 0 01-.235.573.333.333 0 01-.237-.102L9.38 5.136zm-5.438-2.48l.935.34a.333.333 0 11-.228.627l-.935-.34L1.85 8.397a.333.333 0 01-.626-.228L3.18 2.795a.335.335 0 01.038-.107L4.051.405a.667.667 0 01.855-.4L7.061.79a.333.333 0 01.2.428l-.156.426a.547.547 0 00.327.7.333.333 0 11-.229.626 1.213 1.213 0 01-.724-1.554l.041-.113-1.842-.67-.737 2.025v-.001zm7.794 4.837a.334.334 0 01.472-.472l1.414 1.414a.334.334 0 01-.235.573.333.333 0 01-.237-.101l-1.413-1.414z","fill":"#50657c"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-assets-icons-tickets_svg-icon-tickets-clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    